import React, { useState } from "react";
import BasicDataTable from "../../Component/BasicComponents/BasicDataTable";
import PageHeader from "../../Component/BasicComponents/HeaderBreadCrumbs";
import RoundedDropdown from "../../Component/BasicComponents/Dropdowns/RoundedDropdown";
// import AnnouncementModal from "./components/AnnouncementModal";

type Props = {};

function AccountInstructions({}: Props) {
  const [isOpenModal, setIsModalOpen] = useState(false);
  const [modalStatus, setModalStatus] = useState("");

  const handleEditLeaveRequest = () => {
    setModalStatus("Edit");
    setIsModalOpen(true);
  };

  const handleLeaveRequestView = () => {
    setModalStatus("View");
    setIsModalOpen(true);
  };

  // const handleAddAnnouncements = () => {
  //   setModalStatus("Add");
  //   setIsModalOpen(true);
  // };

  return (
    <div className="p-2">
      <PageHeader
        title="Account Instructions"
        buttons={[
          {
            label: "Excel",
            onClick: () => alert("Download Excel"),
            color: "#43B9B2",
          },
          {
            label: "CSV",
            onClick: () => alert("Download CSV"),
            color: "#43B9B2",
          },
        ]}
      />

      {/* Table with Filters */}
      <BasicDataTable
        Title="Expense Reports"
        data={announcementData || []}
        columns={leaveRequestColumns()}
        headerContent={
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexWrap: "wrap",
              gap: "10px",
              marginBottom: "15px",
            }}
          >
            {/* Month Dropdown */}
            <RoundedDropdown
              options={[]}
              onSelect={(e) => console.log("status", e)}
              defaultLabel="All"
              width="120px"
              isShowHeading
              DropdownHeading="Month"
              headingColor="#2e8dd3"
            />
            <RoundedDropdown
              options={[]}
              onSelect={(e) => console.log("status", e)}
              defaultLabel="All"
              width="120px"
              isShowHeading
              DropdownHeading="Division"
              headingColor="#2e8dd3"
            />
          </div>
        }
        // onChangePage={(pageNo: number) => {
        //   handlePagination(pageNo);
        // }}
        // onChangeRowsPerPage={(newPerPage: any, page: any) => {
        //   handleonChangeRowsPerPage(newPerPage, page);
        // }}
        // handleSearch={(val: any) => {
        //   handleSearch(val);
        // }}
        // paginationTotalRows={
        //   leaveRequestDataa?.data?.pagination?.total_records || 0
        // }
        // showheaderContent={true}
      />
    </div>
  );
}

export default AccountInstructions;

const leaveRequestColumns = () => [
  {
    name: "Employee Name",
    selector: (row: { employeename: string }) =>
      row.employeename ? row.employeename : "-",
    sortable: true,
    // width: "180px",
  },
  {
    name: "Designation",
    selector: (row: { designation: string }) => row.designation ?? "-",
    sortable: true,
    // width: "180px",
  },
  {
    name: "Bank",
    selector: (row: { bank: string }) => row.bank ?? "-",
    sortable: true,
    // width: "150px",
  },
  {
    name: "A/C",
    selector: (row: { ac: string }) => row.ac || "-",
    sortable: true,
    // width: "150px",
  },
  {
    name: "Requested",
    selector: (row: { requested: string }) => row.requested || "-",
    sortable: true,
    // width: "150px",
  },
  {
    name: "Approved",
    selector: (row: { approved: string }) => row.approved || "-",
    sortable: true,
    // width: "150px",
  },
  {
    name: "Final Payable",
    selector: (row: { finalpayable: string }) => row.finalpayable || "-",
    sortable: true,
    // width: "150px",
  },
];

const announcementData = [
  {
    employeename: "Test Sample",
    designation: "Test Sample",
    bank: "Test Sample",
    ac: "0",
    requested: "0",
    approved: "0",
    finalpayable: "0",
  },
  {
    employeename: "Test Sample",
    designation: "Test Sample",
    bank: "Test Sample",
    ac: "0",
    requested: "0",
    approved: "0",
    finalpayable: "0",
  },
  {
    employeename: "Test Sample",
    designation: "Test Sample",
    bank: "Test Sample",
    ac: "0",
    requested: "0",
    approved: "0",
    finalpayable: "0",
  },
  {
    employeename: "Test Sample",
    designation: "Test Sample",
    bank: "Test Sample",
    ac: "0",
    requested: "0",
    approved: "0",
    finalpayable: "0",
  },
  {
    employeename: "Test Sample",
    designation: "Test Sample",
    bank: "Test Sample",
    ac: "0",
    requested: "0",
    approved: "0",
    finalpayable: "0",
  },
  {
    employeename: "Test Sample",
    designation: "Test Sample",
    bank: "Test Sample",
    ac: "0",
    requested: "0",
    approved: "0",
    finalpayable: "0",
  },
  {
    employeename: "Test Sample",
    designation: "Test Sample",
    bank: "Test Sample",
    ac: "0",
    requested: "0",
    approved: "0",
    finalpayable: "0",
  },
];
